import { render, staticRenderFns } from "./IntervoiceMicPermission.vue?vue&type=template&id=8d51f076"
import script from "./IntervoiceMicPermission.vue?vue&type=script&lang=js"
export * from "./IntervoiceMicPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports